export const planInfoJSON = {
  planName: "IT Automation Awesomeness Excess Sample",
  contractId: "721928",
  participantName: "Pepper Potts",
};

export const planLogoJSON = {
  documentContent:
    "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",
  textContent: null,
  customValue: false,
  alternativeDisplay: null,
};

export const menuJSON = [
  {
    id: "overview",
    name: "overview",
    heading: "Overview",
    menuItems: [
      {
        id: "plan-dashboard",
        name: "plan-dashboard",
        displayText: "Plan Dashboard",
        target: "_self",
        navigationLink: "http://localhost:3007/overview/dashboard",
      },
      {
        id: "summary-balances-by-account",
        name: "summary-balances-by-account",
        displayText: "Summary/Balances by Account",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=overviewSummary",
      },
      {
        id: "plan-history-summary",
        name: "plan-history-summary",
        displayText: "Plan History",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=planHistorySummary",
      },
      {
        id: "planinfo-forms-summary",
        name: "planinfo-forms-summary",
        displayText: "Plan Info and Forms",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=planInfoFormsSummary",
      },
      {
        id: "personal-details",
        name: "personal-details",
        displayText: "Personal Details",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/overview/personal-details",
      },
      {
        id: "beneficiaries",
        name: "beneficiaries",
        displayText: "Beneficiaries",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/overview/beneficiaries",
      },
      {
        id: "plan-contacts",
        name: "plan-contacts",
        displayText: "Plan Contacts",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=planContacts",
      },
      {
        id: "statements",
        name: "Statements",
        displayText: "Statements",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=statements",
      },
      {
        id: "ondemand-statement",
        name: "ondemand-statement",
        displayText: "On-Demand Statement",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/overview/statements",
      },
    ],
    isRendered: true,
  },
  {
    id: "contribution",
    name: "contributions",
    heading: "Contributions",
    menuItems: [
      {
        id: "contributions-summary",
        name: "contributions-summary",
        displayText: "Contribution Summary",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/contributions/summary",
      },
      {
        id: "balances-by-source",
        name: "balances-by-source",
        displayText: "Balances by Source",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=balancesBySource",
      },
      {
        id: "account-allocations",
        name: "account-allocations",
        displayText: "Account Allocations",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/contributions/account-allocations",
      },
    ],
    isRendered: true,
  },
  {
    id: "investment",
    name: "investments",
    heading: "Investments",
    menuItems: [
      {
        id: "investments-summary",
        name: "investments-summary",
        displayText: "Investment Summary",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/summary",
      },
      {
        id: "investments-manage-fund-allocations",
        name: "investments-manage-fund-allocations",
        displayText: "Change Investments",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/manage",
      },
      {
        id: "performance",
        name: "performance",
        displayText: "Investment Performance",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/performance",
      },
      {
        id: "investment-allocations",
        name: "investment-allocations",
        displayText: "Investment Allocations",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/investment-allocations",
      },
      {
        id: "rate-of-return",
        name: "rate-of-return",
        displayText: "Personalized Rate of Return",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/rate-of-return",
      },
      {
        id: "research",
        name: "research",
        displayText: "Research",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nq-participant/investments/research",
      },
    ],

    isRendered: true,
  },
  {
    id: "distribution",
    name: "distributions",
    heading: "Distribution",
    menuItems: [],
    navigationLink:
      "http://localhost:3007/nq-participant/distributions/summary",
    isRendered: true,
  },
  {
    id: "enrollment",
    name: "enrollmentcenter",
    heading: "Enrollment Center",
    menuItems: [
      {
        id: "enrollment-center-summary",
        name: "enrollment-center-summary",
        displayText: "Enrollment Summary",
        target: "_self",
        navigationLink:
          "http://localhost:3007/rnqenrollment/enrollment/participant-landing",
      },
      {
        id: "enrollment-center-tools",
        name: "enrollment-center-tools",
        displayText: "Tools",
        target: "_self",
        navigationLink:
          "http://localhost:3007/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=enrollmentCenterTools",
      },
    ],
    isRendered: true,
  },
  {
    id: "planningResources",
    name: "planningResources",
    heading: "Planning Resources",
    menuItems: [
      {
        id: "planning-center",
        name: "planning-center",
        displayText: "Planning Center",
        target: "_self",
        navigationLink:
          "https://secure05.pilot.principal.com/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=planningCenter&planId=13464&empId=290024",
      },
      {
        id: "principal-milestones",
        name: "principal-milestones",
        displayText: "Principal Milestones",
        target: "_self",
        navigationLink:
          "https://landing.principal.com/milestone-planning#Plan-for-Tomorrow",
      },
      {
        id: "other-links",
        name: "other-links",
        displayText: "Other Links",
        target: "_self",
        navigationLink:
          "https://secure05.pilot.principal.com/nqParticipant/pensionContext.faces?contractId=721928&memberId=MjkwMDI0&action=otherLinks&planId=13464&empId=290024",
      },
    ],
    isRendered: true,
  },
];

export const messageListJSON = [];

export const headerHTML = `<header
    class="navbar-principal-primary navbar-authenticated"
    data-navbar-principal-primary-persona="member"
    data-navbar-principal-primary-include-tier-two-in-mobile-menu="false"
    data-navbar-principal-primary-include-alert="false"
>
  <nav class="navbar navbar-default navbar-static-top" role="navigation">
    <div class="navbar-header">
      <div class="container">
        <div class="logo-full-tier1 visible-xs visible-sm visible-md">
          <a
              id="tsm-header-logo-mobile"
              href="https://secure05.pilot.principal.com/member/accounts"
              class="navbar-brand logo-full-white"
          >Principal</a
          >
        </div>
        <ul class="mobile-nav-right visible-xs visible-sm visible-md">
          <li>
            <a
                id="tsm-header-logout-mobile"
                class="navbar-toggle mobile-nav-logout-btn"
                href="https://secure05.pilot.principal.com/auth/corp/logout.jsp"
            >
              <i class="fa fa-user" aria-hidden="true"></i>Log Out
            </a>
          </li>
          <li>
            <a
                class="navbar-toggle"
                data-toggle="collapse"
                data-target="#principal-primary-navbar"
                href="#"
            >
              <i class="fa fa-navicon" aria-hidden="true"></i>Menu
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="container panel">
      <div class="collapse navbar-collapse" id="principal-primary-navbar">
        <ul class="nav navbar-nav navbar-left">
          <li class="hidden-xs hidden-sm logo-full-tier1">
            <a
                id="tsm-header-logo"
                class="logo-full-white"
                href="https://secure05.pilot.principal.com/member/accounts"
            >Principal</a
            >
          </li>
          <li class="dropdown">
            <a
                id="tsm-header-my-accounts"
                class="visible-xs visible-sm visible-md"
                href="#"
            >My Accounts here</a
            >
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              <span class="hidden-xs hidden-sm hidden-md">My Accounts</span>
              <div class="dropdown-caret">&nbsp;</div>
            </a>
            <div class="dropdown-menu">
              <ul>
                <li class="dropdown-secondary">
                  <a
                      id="tsm-header-overview"
                      href="https://secure05.pilot.principal.com/member/accounts"
                  >Overview</a
                  >
                </li>
                <ul class="principal-primary-navbar-account-list"></ul>
              </ul>
            </div>
          </li>
          <li>
            <a
                id="tsm-header-help"
                href="https://secure05.pilot.principal.com/allweb/docs/corporate/help.htm"
            >Help</a
            >
          </li>
          <li class="visible-xs visible-sm visible-md">
            <a
                id="tsm-header-my-profile-mobile"
                href="https://secure05.pilot.principal.com/yourprofile/isea/member/yourprofile.jsp"
            >My Profile</a
            >
          </li>
          <li
              class="principal-primary-navbar-msg-count visible-xs visible-sm visible-md"
          >
            <a
                id="tsm-header-messages-mobile"
                href="https://secure05.pilot.principal.com/servlet/common/member/messagecenter"
            >Messages</a
            >
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-right hidden-xs hidden-sm hidden-md">
          <li>
            <a
                id="tsm-header-my-profile"
                href="https://secure05.pilot.principal.com/yourprofile/isea/member/yourprofile.jsp"
            >My Profile</a
            >
          </li>
          <li class="principal-primary-navbar-msg-count">
            <a
                id="tsm-header-messages"
                href="https://secure05.pilot.principal.com/servlet/common/member/messagecenter"
            >Messages</a
            >
          </li>
          <li class="logout">
            <span>
              <a
                  id="tsm-header-log-out"
                  href="https://secure05.pilot.principal.com/auth/corp/logout.jsp"
                  class="btn btn-primary navbar-btn"
              >Log Out</a
              >
            </span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>`;
